import React, { useState, useEffect } from 'react';
import {
  Button,
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
  Snackbar,
} from '@mui/material';
import { read, utils } from 'xlsx';
import { can } from '../../Conections/LogConections';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import { SetEstudentArrayCreate } from '../../Conections/AcademicConection';

function EstudentsRegister() {

  const { getToken, getCompany } = useAuth();
  const goTo = useNavigate();
  const idGruop = useParams();

  const [excelData, setExcelData] = useState([]);
  const [showExample, setShowExample] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  const exampleData = [
    { codigo: '001', nombre: 'Juan', apellido: 'Pérez', email: 'juan@example.com', estado: 'SI' },
    { codigo: '002', nombre: 'María', apellido: 'González', email: 'maria@example.com', estado: 'SI' },
    { codigo: '003', nombre: 'Carlos', apellido: 'Rodríguez', email: 'carlos@example.com', estado: 'NO' },
  ];

  useEffect(() => {
    reloaduser();
    const timer = setTimeout(() => {
      setShowExample(false);
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  async function reloaduser() {
    if (getToken()) {
      const permisionCan = await can(getToken(), getCompany(), "/academic/registerestudent/:group");
      if (permisionCan === 0) {
        goTo("/dashboard");
      }
    }
    else {
      goTo(`/login`);
    }
  }

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const bstr = evt.target.result;
        const wb = read(bstr, { type: 'binary' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = utils.sheet_to_json(ws, { header: 1 });

        if (data.length > 1) {
          const headers = data[0];
          const expectedHeaders = ['codigo', 'nombre', 'apellido', 'email', 'estado'];

          if (JSON.stringify(headers) === JSON.stringify(expectedHeaders)) {
            const formattedData = data.slice(1).map(row => {
              return expectedHeaders.reduce((obj, header, index) => {
                obj[header] = row[index] || '';
                return obj;
              }, {});
            });
            setExcelData(formattedData);
            setSnackbar({ open: true, message: 'Datos cargados exitosamente', severity: 'success' });
          } else {
            setSnackbar({ open: true, message: 'El formato del archivo no es correcto. Verifica los encabezados.', severity: 'error' });
          }
        } else {
          setSnackbar({ open: true, message: 'El archivo está vacío o no contiene datos válidos', severity: 'error' });
        }
      } catch (error) {
        console.error('Error al procesar el archivo:', error);
        setSnackbar({ open: true, message: 'Hubo un error al procesar el archivo. Inténtalo de nuevo.', severity: 'error' });
      }
    };
    reader.onerror = (error) => {
      console.error('Error al leer el archivo:', error);
      setSnackbar({ open: true, message: 'Hubo un error al leer el archivo. Inténtalo de nuevo.', severity: 'error' });
    };
    reader.readAsBinaryString(file);
  };

  const handleSendToBackend = async () => {
    console.log("Enviar:");
    console.log(excelData);

    const groupid = Number(idGruop.group);
    const datos = await SetEstudentArrayCreate(
      getToken(),
      getCompany(),
      groupid,
      excelData
    );
    console.log(datos);
    goTo(`/academic/showgroup/${groupid}`);

  };

  return (
    <Container component="main" maxWidth="md">
      <Paper elevation={3} sx={{ p: 4, mt: 8 }}>
        <Typography component="h1" variant="h5" gutterBottom>
          Registro de Estudiantes
        </Typography>
        <Alert severity="info" sx={{ mb: 2 }}>
          Para usar este componente, prepare un archivo Excel con columnas para: código, nombre, apellido, email y estado.
          Luego, haga clic en "Subir archivo Excel" para cargar y visualizar los datos.
        </Alert>
        <box style={{ display: 'flex', flexDirection: 'row' }}>
          <input
            accept=".xlsx, .xls"
            style={{ display: 'none' }}
            id="raised-button-file"
            type="file"
            onChange={handleFileUpload}
          />
          <label htmlFor="raised-button-file">
            <Button variant="contained" component="span" sx={{ bgcolor: 'primary.main', '&:hover': { bgcolor: 'primary.dark' }, mr: 2 }}>
              Subir archivo Excel
            </Button>
          </label>
          <Button
            variant="contained"
            onClick={handleSendToBackend}
            disabled={excelData.length === 0}
            sx={{ bgcolor: 'secondary.main', '&:hover': { bgcolor: 'secondary.dark' } }}
          >
            Guardar
          </Button>
        </box>
        {showExample && (
          <Box sx={{ mb: 4, paddingTop: 5}}>
            <Typography variant="h6" gutterBottom>
              Ejemplo de datos:
            </Typography>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="tabla de ejemplo">
                <TableHead>
                  <TableRow>
                    <TableCell>Código</TableCell>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Apellido</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Estado</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {exampleData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.codigo}</TableCell>
                      <TableCell>{row.nombre}</TableCell>
                      <TableCell>{row.apellido}</TableCell>
                      <TableCell>{row.email}</TableCell>
                      <TableCell>{row.estado}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}

        {excelData.length > 0 && (
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="tabla de estudiantes">
              <TableHead>
                <TableRow>
                  <TableCell>Código</TableCell>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Apellido</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Estado</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {excelData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.codigo}</TableCell>
                    <TableCell>{row.nombre}</TableCell>
                    <TableCell>{row.apellido}</TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>{row.estado}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}

export default EstudentsRegister;